<template>
  <div id="login-div">
    <h1 class="page-title mt-5 bold-text confirm-email">
      <chevron-left-icon class="cursor-pointer chevron-color" @click="backToLogin"/>
      {{ $t('user.email.confirm') }}
    </h1>

    <div v-if="sendWithSuccess" class="confirm-email success-mail mt-4">
      <check-icon class="check-icon-successful"></check-icon>
      <p class="text-successful ml-2">{{ this.$t('user.mail.send') }}</p>
    </div>
    <div class="mt-4 send-email">
      <p v-html="$t('user.create.successful', { mail :email })"></p>
    </div>

    <div class="mt-4">
      <b-button :disabled="timer > 0" class="btn-block bold-text" type="submit" variant="secondary" @click="resendMail">
        {{ timer > 0 ? $t('user.resend.mail.timer', {timer: this.timer}) : $t('user.resend.mail') }}
      </b-button>
    </div>
  </div>
</template>

<script>
import api from '../../services/api'
import _ from 'lodash'

export default {
  name: "UserCreateSuccessful",
  props: {
    email: {
      type: String,
      default: "",
      required: true
    }
  },
  data() {
    return {
      timer: 0,
      sendWithSuccess: true
    }
  },
  emits: ['showLoginView'],
  watch: {
    timer: function (newValue) {
      if (newValue <= 110) {
        this.sendWithSuccess = false
      }
    },
  },
  methods: {
    backToLogin() {
      this.$emit('showLoginView')
    },
    startTimer() {
      this.timer = 120;
      const interval = setInterval(() => {
        if (this.timer > 0) {
          this.timer--;
        } else {
          clearInterval(interval);
        }
      }, 1000);
    },
    resendMail() {
      if (this.timer > 0) return;

      let formData = new FormData()
      formData.append('username', this.email)
      api({
        method: 'POST',
        url: `/authentication/resendValidateAccountMail`,
        data: formData
      })
        .then(() => {
          this.sendWithSuccess = true
          this.startTimer();

        })
    }
  }
}
</script>


<style scoped>
.confirm-email {
  display: flex;
  align-items: center;
  padding: 0.5em;
}

.chevron-color {
  color: var(--secondary-color)
}

.success-mail {
  background: #EDFCF0 0% 0% no-repeat padding-box;
  border: 2px solid #00A01F;
  border-radius: 4px;
  opacity: 1;
  min-height: 2em;
}

.check-icon-successful {
  color: #1E8C9E;
  margin-left: 0.5em;
}

.text-successful {
  font-family: "Montserrat-Bold", "Arial", sans-serif;
  font-weight: 500;
  display: flex;
  margin-bottom: unset;
}

.send-email {
  color: #000122;
  text-align: left;
  letter-spacing: 0px;
  font-size: 16px;
}

.btn-secondary:disabled {
  background-color: #6c757d !important;
  border-color: #6c757d !important;
  color: #FFFFFF !important;
}
</style>



// WEBPACK FOOTER //
// src/views/auth/UserCreateSuccessful.vue